<div class="sidebar" [ngClass]="{ 'expanded': isExpanded }">
  <div class="header">
    <h1 class="title">
      FXCH
    </h1>
    <div class="toggle" (click)="handleSidebarToggle()">
      <span class="chevron"></span>
    </div>
  </div>
  <div class="content">
    <div class="link">
      <div class="content" [routerLink]="['/user-management']" [routerLinkActive]="'active'">
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        <div class="title">User management</div>
      </div>
    </div>
<!--    <div class="link">-->
<!--      <div class="content" [routerLink]="['/permission-management']" [routerLinkActive]="'active'">-->
<!--        <ng-container *ngTemplateOutlet="icon"></ng-container>-->
<!--        <div class="title">Permission management</div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="link">
      <div class="content" [routerLink]="['/import-users']" [routerLinkActive]="'active'">
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        <div class="title">Import users</div>
      </div>
    </div>
  </div>
  <div class="footer">
    <button class="btn btn-primary logoutButton" (click)="logout()">
      <span class="logoutText" *ngIf="isExpanded">Sign out</span><i class="fa fa-lg fa-sign-out"></i>
    </button>
  </div>
</div>


<ng-template #icon>
  <div class="icon">
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Stockholm-icons / Home / Flower2</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Stockholm-icons-/-Home-/-Flower2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon id="bound" points="0 0 24 0 24 24 0 24"></polygon>
        <circle id="Oval-32" fill="white" opacity="0.3" cx="15" cy="17" r="5"></circle>
        <circle id="Oval-32-Copy" fill="white" opacity="0.3" cx="9" cy="17" r="5"></circle>
        <circle id="Oval-32-Copy-2" fill="white" opacity="0.3" cx="7" cy="11" r="5"></circle>
        <circle id="Oval-32-Copy-3" fill="white" opacity="0.3" cx="17" cy="11" r="5"></circle>
        <circle id="Oval-32-Copy-4" fill="white" opacity="0.3" cx="12" cy="7" r="5"></circle>
      </g>
    </svg>
  </div>
</ng-template>
